import React from 'react';
import ClickHandlerWithLoaderContainer from '../../../../Common/ClickHandlerWithLoader/ClickHandlerWithLoaderContainer';
import SettingsRow from '../../../Common/SettingsRow/SettingsRow';

import MenuBuilderIcon from '../../../../Common/MenuBuilderIcon';

import Mixpanel from 'qs-data-manager/Mixpanel';
import { getI18N } from 'qs-services/i18N';

export default ({ onSelected, settingComponentId, classForContainer }) => {
  const { t } = getI18N();

  const onClick = onSelectedParameters => {
    Mixpanel.sendEvent({
      eventName: 'menu_builder_clicked',
      props: {
        source: 'web'
      }
    });
    if (typeof onSelected === 'function') {
      onSelected(onSelectedParameters);
    }
  };
  return (
    <ClickHandlerWithLoaderContainer
      clickProps={{
        clickHandler: onClick,
        clickParams: settingComponentId
      }}
      type="button"
      classForContainer={classForContainer}
    >
      <SettingsRow Icon={MenuBuilderIcon} title={t('menu_builder')}>
        <span>{t('design_your_menu')}</span>
      </SettingsRow>
    </ClickHandlerWithLoaderContainer>
  );
};
